import { z } from "zod";

import { safeString } from "@/schema/public/components/base/safe-string.schema";

export const teacherTipsSchema = z.object({
  teacher_tip: safeString,
});

export type TeacherTips = z.infer<typeof teacherTipsSchema>;

export const teacherTipsSchemaCamel = z.object({
  teacherTip: z.string(),
});
export type TeacherTipsCamel = z.infer<typeof teacherTipsSchemaCamel>;
